export default "__VITE_ASSET__9YiKTHCo__"